import React from "react";
import { Paper } from "@material-ui/core";
import styled from "styled-components";

import PageWrapper from "./PageWrapper";

const PaperWrapper = styled(Paper)`
  width: 35%;
  margin: auto;
  padding: 20px;
  border-top: 10px solid #e69329;
  border-radius: 7px !important;
  text-align: center;
`;

const LoginWrapper = (props) => (
  <PageWrapper loginform="yes" needSidebar="no">
    <PaperWrapper>
      <h3>GK-MemberShip Administrator</h3>
      {props.children}
    </PaperWrapper>
  </PageWrapper>
);

export default LoginWrapper;
